import { MutableRefObject } from 'react'
import {
  ProgressOverviewPageConfig,
  VersionReportVersionPageRowEntity,
} from '../../../../../domain/entity/version-report/VersionReportVersionEntity'
import { MasterSchedule } from '../master-schedule'
import { useProjectPrivateContext } from '../../../../context/projectContext'
import { StoredVersionReportPageDisplayState } from '../../hooks/pageDisplayState'
import { PendingEdits } from '../../hooks/currentReport'

type ProgressOverviewProps = {
  editable: boolean
  snapshotUuid: string
  config: ProgressOverviewPageConfig
  rows: VersionReportVersionPageRowEntity[]
  updateRow: (
    rowUuid: string,
    lockVersion: number,
    key: 'status' | 'comment',
    value: string
  ) => Promise<boolean>
  takenAt?: Date
  displayState: StoredVersionReportPageDisplayState
  updateDisplayState: (
    updated: Partial<StoredVersionReportPageDisplayState>
  ) => void
  displayStateRestoreToken?: number
  pendingEditsRef: MutableRefObject<PendingEdits>
  discardToken: number
  callbackWhenStartLoading?: () => void
  callbackWhenFinishLoading?: () => void
}
export const ProgressOverview = ({
  editable,
  snapshotUuid,
  config,
  rows,
  updateRow,
  takenAt,
  displayState,
  updateDisplayState,
  displayStateRestoreToken,
  pendingEditsRef,
  discardToken,
  callbackWhenStartLoading,
  callbackWhenFinishLoading,
}: ProgressOverviewProps) => {
  const { projectUuid } = useProjectPrivateContext()
  return (
    <MasterSchedule
      editable={editable}
      projectUuid={projectUuid}
      targetUuids={config.tableRows}
      pageRows={rows}
      updateRow={updateRow}
      rootUuid=""
      snapshotUuid={snapshotUuid}
      baseDate={takenAt}
      displayState={displayState}
      updateDisplayState={updateDisplayState}
      displayStateRestoreToken={displayStateRestoreToken}
      pendingEditsRef={pendingEditsRef}
      discardToken={discardToken}
      callbackWhenStartLoading={callbackWhenStartLoading}
      callbackWhenFinishLoading={callbackWhenFinishLoading}
    />
  )
}
